import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS } from './config';
import { Form } from '@tencent/wb-ext-form';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { IBackgroundFeature } from './bg-interface';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';

@Controller({ formItems: FORM_CONFIGS })
export class BackgroundController {
    constructor(@Loader(IBackgroundFeature) private loader: IDynamicLoader<IBackgroundFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.SHOW_MASTER_SHAPE, 'value')
    public getShowMasterSpVal(): boolean {
        return !this.feature.getShowMasterSp();
    }

    @Form(FormItemName.SHOW_MASTER_SHAPE, 'onChange')
    public changeShowMasterSp(isHidden: boolean): void {
        this.feature.updateProps(ActionType.SHOW_MASTER_SHAPE, { showMasterSp: !isHidden });
    }

    // @ts-ignore
    @Form(FormItemName.SHOW_MASTER_SHAPE, 'shouldDisabled')
    public shouldShowMasterSpDisabled(): boolean {
        return !(this.feature.curModelIsLayout || this.feature.curModelIsSlide);
    }

    @Form(FormItemName.SHOW_MASTER_SHAPE, 'shouldHide')
    public shouldHideMasterShape(): boolean {
        return !this.feature.isSlideBg;
    }
}
